import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/feature-succeed.png'
import _imports_1 from '@/assets/image/feature-fail.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c9e8e04e")

_pushScopeId("data-v-c9e8e04e")
const _hoisted_1 = { class: "one-td one-tr" }
const _hoisted_2 = { class: "one-td" }
const _hoisted_3 = {
  key: 0,
  style: {"vertical-align":"middle"},
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  style: {"vertical-align":"middle"},
  src: _imports_1
}
const _hoisted_5 = {
  key: 0,
  class: "tr-hover"
}
const _hoisted_6 = { class: "one-td" }
const _hoisted_7 = {
  key: 0,
  style: {"vertical-align":"middle"},
  src: _imports_0
}
const _hoisted_8 = {
  key: 1,
  style: {"vertical-align":"middle"},
  src: _imports_1
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ProperAllTextReadInstructions,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('close'))),
    width: `${(35+(_ctx.featurePlanData.length-1)*5)}%`,
    footerType: "customize"
  }, {
    default: _withId(() => [
      _createVNode("table", null, [
        _createVNode("tr", null, [
          _createVNode("td", _hoisted_1, _toDisplayString(_ctx.$wordList.ProperAllTextFeature), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.featurePlanData, (item) => {
            return (_openBlock(), _createBlock("td", {
              class: "one-tr",
              key: item.ID
            }, _toDisplayString(item.Name), 1))
          }), 128))
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trHeader, (header) => {
          return (_openBlock(), _createBlock("tr", {
            key: header.value,
            class: "tr-hover"
          }, [
            _createVNode("td", _hoisted_2, _toDisplayString(header.label), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.featurePlanData, (item) => {
              return (_openBlock(), _createBlock("td", {
                key: item.ID
              }, [
                (item.Items.includes(header.value))
                  ? (_openBlock(), _createBlock("img", _hoisted_3))
                  : (_openBlock(), _createBlock("img", _hoisted_4))
              ]))
            }), 128))
          ]))
        }), 128)),
        (_ctx.isShowLastRow && _ctx.projectType==='community')
          ? (_openBlock(), _createBlock("tr", _hoisted_5, [
              _createVNode("td", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextRequestsOneIndoorMonitor), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.featurePlanData, (item) => {
                return (_openBlock(), _createBlock("td", {
                  key: item.ID
                }, [
                  (item.MonitorType===1)
                    ? (_openBlock(), _createBlock("img", _hoisted_7))
                    : (_openBlock(), _createBlock("img", _hoisted_8))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "width"]))
})